export const DriverIcon = () => {
  return (
    <svg
      width="48"
      height="40"
      viewBox="0 0 48 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.72732 9.81872C5.45801 9.66279 5.38951 9.27567 5.57433 8.95466C5.75937 8.63325 6.1277 8.49957 6.39702 8.6555L19.2845 16.117C19.5542 16.2732 19.6225 16.6597 19.4375 16.9811C19.2524 17.3025 18.8845 17.4364 18.6148 17.2802L5.72732 9.81872Z"
        fill="#2C3236"
      />
      <path
        d="M8.95416 12.6814C8.89012 12.4343 9.85668 10.3032 10.4072 9.91695C10.9574 9.53112 18.0944 11.7701 17.8332 12.6049C17.5721 13.4404 15.1991 17.5622 14.73 17.995C14.2608 18.4278 9.11028 13.2857 8.95416 12.6814Z"
        fill="#14B2B6"
      />
      <path
        d="M28.2576 22.8636C27.9879 22.7075 27.9198 22.3206 28.1046 21.9996C28.2896 21.6782 28.658 21.5445 28.9273 21.7004L41.8151 29.1622C42.0845 29.3181 42.1532 29.7048 41.9681 30.0262C41.7831 30.3476 41.4148 30.4813 41.1454 30.3254L28.2576 22.8636Z"
        fill="#2C3236"
      />
      <path
        d="M14.8125 18.6461C14.4328 18.2642 17.4917 12.6694 18.4167 12.3858C19.3405 12.1025 25.9232 15.5868 25.8111 16.667C25.6994 17.7474 22.9431 22.5349 22.2069 22.9273C21.4713 23.3195 15.1908 19.0284 14.8125 18.6461Z"
        fill="#E0F6F7"
      />
      <path
        d="M19.4424 10.33L18.7207 9.91211L12.5629 20.6077L13.2846 21.0256L19.4424 10.33Z"
        fill="#C6C6C6"
      />
      <path
        d="M14.1612 19.5023C14.3023 19.6914 13.3211 21.454 13.0793 21.9852C12.8375 22.5165 11.8747 21.879 12.0969 21.4164C12.3191 20.9539 13.1754 19.11 13.4395 19.0845C13.704 19.0591 14.0206 19.3135 14.1612 19.5023Z"
        fill="#093B59"
      />
      <path
        d="M18.7937 11.4569C19.0271 11.4846 20.0336 9.79566 20.3972 9.27542C20.7608 8.75518 19.7184 8.2596 19.4148 8.70665C19.1112 9.15369 17.9621 10.7969 18.072 11.039C18.1824 11.2814 18.5603 11.4291 18.7937 11.4569Z"
        fill="#093B59"
      />
      <path
        d="M14.0233 16.7953C13.9266 16.6287 16.0472 12.8551 16.4705 12.5448C16.894 12.234 19.0588 13.2658 18.8459 13.9201C18.633 14.5744 16.7614 17.8252 16.3987 18.1706C16.0358 18.5165 14.1192 16.9625 14.0233 16.7953Z"
        fill="#E0F6F7"
      />
      <path
        d="M15.0112 16.991C14.9664 16.8682 16.8277 13.5815 17.1469 13.2815C17.4662 12.9814 18.7881 13.553 18.5687 14.1046C18.3493 14.6562 16.7162 17.4928 16.433 17.8142C16.15 18.1353 15.0556 17.1136 15.0112 16.991Z"
        fill="#375C7C"
      />
      <path
        d="M34.0134 21.947C34.6718 22.2213 35.051 23.081 34.739 23.9338C34.5607 24.4213 33.9659 24.7176 33.7472 25.1569C33.5503 25.5526 33.4198 26.3246 33.2071 26.7142C32.5042 27.9998 30.2917 27.6654 30.7961 26.7666L34.0137 21.9466L34.0134 21.947Z"
        fill="black"
      />
      <path
        d="M25.3184 27.9944C23.8966 27.1712 26.6943 24.8752 28.0503 22.5199C29.4063 20.1646 29.0998 15.647 30.5212 16.47C31.9426 17.2929 35.5702 21.3817 33.1988 25.5008C30.8273 29.6198 26.7402 28.8176 25.3184 27.9944Z"
        fill="#464646"
      />
      <path
        d="M21.5489 17.0305C21.5489 17.0305 19.0132 15.4339 18.6921 14.6484C18.3711 13.8629 19.0442 12.4247 20.049 12.2916C21.0537 12.1588 23.751 12.8929 23.751 12.8929L21.5489 17.0305Z"
        fill="#F9BB8D"
      />
      <path
        d="M20.5452 18.7758C20.5452 18.7758 17.8986 17.3719 17.0597 17.4858C16.2208 17.5998 15.3153 18.9034 15.7028 19.8427C16.0904 20.7815 18.073 22.757 18.073 22.757L20.5452 18.7758Z"
        fill="#F9BB8D"
      />
      <path
        d="M22.2422 28.0322L21.4075 25.2319C21.4075 25.2319 19.793 25.4427 18.3733 24.7392C15.8156 23.4716 14.0178 20.9534 14.0178 20.9534C14.0178 20.9534 13.3854 19.3701 13.0904 19.4804C12.7956 19.5903 12.1519 20.4585 12.2011 21.0251C12.2503 21.5916 13.0795 21.9859 13.0795 21.9859C13.0795 21.9859 14.2433 26.0064 17.079 27.3602C19.8401 28.6783 22.2424 28.0328 22.2424 28.0328L22.2422 28.0322Z"
        fill="#F9BB8D"
      />
      <path
        d="M30.1422 14.3111L27.3065 14.9863C27.3065 14.9863 26.6814 13.4788 25.3639 12.5975C22.9904 11.0101 19.9168 10.7078 19.9168 10.7078C19.9168 10.7078 18.2333 10.9503 18.181 10.6389C18.1285 10.3279 18.5565 9.33479 19.0703 9.09425C19.5841 8.85371 20.3393 9.37674 20.3393 9.37674C20.3393 9.37674 24.3933 8.37719 26.9802 10.1629C29.4991 11.9019 30.1428 14.3109 30.1428 14.3109L30.1422 14.3111Z"
        fill="#F9BB8D"
      />
      <path
        d="M17.6892 22.3631C17.4409 21.7166 19.6727 18.4465 19.9174 18.3744C20.1617 18.3021 23.5345 19.8316 23.5345 19.8316L23.8559 19.2733C23.8559 19.2733 21.222 17.2692 21.0958 16.7908C20.9699 16.3119 23.751 12.8939 23.751 12.8939C23.751 12.8939 28.4033 14.1587 29.8177 16.9581C31.0203 19.3391 29.9102 19.7345 28.5125 22.7137C27.1143 25.6932 25.7214 26.6735 24.0678 26.739C21.5532 26.8393 17.9371 23.0095 17.6892 22.3631Z"
        fill="#464646"
      />
      <path
        d="M20.8159 22.3041C21.2101 21.1662 21.873 19.3272 23.7159 17.3682C24.7538 16.2649 25.7787 15.9901 26.0024 15.4174C26.2227 14.8542 25.7853 13.5722 25.7853 13.5722L29.264 12.1733C29.264 12.1733 30.5824 13.7732 31.0986 15.7699C31.5691 17.589 31.491 18.2061 32.1312 19.4686C33.4897 22.1488 29.8947 27.6563 28.0105 28.0585C25.8446 28.5213 23.6773 28.3657 22.6028 28.5807C20.0436 29.0938 17.9608 27.8878 17.9608 27.8878L18.6555 24.6212C18.6555 24.6212 20.1282 24.7715 20.3139 24.3978C20.6672 23.6885 20.5942 22.9444 20.8159 22.3041Z"
        fill="black"
      />
      <path
        d="M23.3492 23.5152C22.5251 23.0381 21.0923 21.7616 20.7624 21.0336C20.4322 20.3049 20.1955 18.5769 20.4671 18.105C20.7388 17.6332 22.7022 16.9237 23.4105 16.9036C24.1183 16.8833 25.8738 17.2737 26.6754 17.7378C28.3945 18.7331 29.1217 20.5941 28.1292 22.318C27.1367 24.0419 25.0683 24.5105 23.3492 23.5152Z"
        fill="#F9BB8D"
      />
      <path
        d="M21.2762 22.1972C21.0036 21.8809 20.8739 21.5463 20.9859 21.4495C21.0978 21.3526 21.4092 21.5303 21.6813 21.8463C21.9535 22.1624 22.0832 22.497 21.9713 22.5938C21.8593 22.6907 21.5477 22.5134 21.2762 22.1972Z"
        fill="#F9BB8D"
      />
      <path
        d="M24.4086 16.7566C23.9992 16.678 23.6454 16.7327 23.6177 16.8783C23.5901 17.0239 23.8992 17.2055 24.3082 17.2839C24.7172 17.3622 25.0713 17.3071 25.0989 17.1615C25.1266 17.0159 24.8175 16.8343 24.4088 16.7562L24.4086 16.7566Z"
        fill="#F9BB8D"
      />
      <path
        d="M23.18 23.7425C22.3292 23.3146 21.0928 21.7617 20.7624 21.0335C20.4323 20.3048 21.0035 18.8292 21.275 18.3578C21.5464 17.8863 22.7023 16.9236 23.4105 16.9035C24.1184 16.8832 25.9752 17.0364 26.7352 17.5665C29.1518 19.2515 29.1914 21.5335 28.5126 22.7125C27.8338 23.8915 25.7158 25.018 23.1796 23.7423L23.18 23.7425Z"
        fill="#C02B35"
      />
      <path
        d="M22.4093 23.1674C22.4093 23.1674 22.4065 23.1658 22.4064 23.1641C21.7083 22.512 21.0002 21.5571 20.7621 21.0333C20.431 20.3052 21.0028 18.8289 21.274 18.3578C21.5452 17.8868 22.7011 16.924 23.4106 16.9036C23.9594 16.8876 25.2042 16.977 26.0877 17.2669C26.3423 17.3491 26.5661 17.4491 26.735 17.567C29.151 19.2511 29.1913 21.5329 28.512 22.7127C27.8328 23.8925 25.7155 25.0179 23.1797 23.7424C22.9433 23.624 22.6771 23.4172 22.4093 23.1674Z"
        fill="#163738"
      />
      <path
        d="M22.4102 23.1684C22.4102 23.1684 22.4075 23.1668 22.4074 23.1652C21.9983 22.6446 21.659 22.1007 21.5154 21.7427C21.2071 20.9751 21.8545 19.3673 22.1519 18.8509C22.4492 18.3344 23.674 17.252 24.401 17.2012C24.7658 17.1749 25.4272 17.1841 26.0887 17.268C26.3432 17.3501 26.567 17.4502 26.736 17.568C29.152 19.2522 29.1922 21.534 28.5129 22.7138C27.8337 23.8936 25.7164 25.0189 23.1806 23.7435C22.9443 23.6251 22.678 23.4182 22.4102 23.1684Z"
        fill="#14B2B6"
      />
      <path
        d="M44.6394 26.1812L36.4209 21.4229L31.6759 29.6645L39.8944 34.4228L44.6394 26.1812Z"
        fill="#14B2B6"
      />
    </svg>
  );
};

export const PinDeliveryIcon = () => {
  return (
    <svg
      width="42px"
      height="42px"
      viewBox="0 0 42 42"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Group 6</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Delivery-map"
          transform="translate(-155.000000, -435.000000)"
          fill="#14B2B6"
          stroke="#14B2B6"
        >
          <g id="Group-6" transform="translate(155.999997, 436.000000)">
            <g id="Group-3" transform="translate(0.000000, 28.000000)">
              <path
                d="M23.9289062,0.919717886 C23.9345947,1.40924056 24.3275892,1.806232 24.8174507,1.81792015 C30.8976502,2.05030341 33.1177084,2.79006624 35.5792059,3.69841448 C36.8099546,4.15279151 37.5873295,4.66041459 37.9308339,5.04563671 C38.2743384,5.43085883 38.2701939,5.54595469 38.1469971,5.83572354 C38.0238816,6.12557356 37.5759525,6.62045331 36.717232,7.10461891 C35.8585928,7.58878451 34.6256499,8.06945989 33.0644803,8.48065569 C29.9424661,9.30345313 25.5110392,9.85888401 20.0036723,9.85888401 C14.6151138,9.85888401 10.2259444,9.31294975 7.09564127,8.50029829 C5.53065222,8.09421606 4.28056256,7.61922241 3.39494357,7.13692367 C2.50932457,6.65470609 2.01791898,6.15406344 1.8680675,5.84773637 C1.71821602,5.54149047 1.71130855,5.45017675 2.0112553,5.08524657 C2.31120206,4.72031639 3.03786797,4.21618352 4.22603418,3.76180649 C6.6023666,2.85280891 8.7531876,2.09656902 14.8033192,1.83155634 C15.0477624,1.82457591 15.2788783,1.72027536 15.4451451,1.54211216 C15.6114933,1.36354312 15.6990963,1.12612746 15.6883694,0.882624226 C15.6778863,0.63912099 15.5696421,0.410146781 15.3883414,0.246918445 C15.2067968,0.0839336126 14.967717,0.000168499479 14.7239239,0.0151033646 C8.56213509,0.28490495 6.28714215,1.02653464 3.57535045,2.06393959 C2.21953586,2.58268265 1.23648089,3.16351904 0.605056811,3.93144707 C-0.0262860047,4.69937511 -0.18629553,5.78848392 0.233028569,6.64577764 C0.652352668,7.50307137 1.45199397,8.14957246 2.52395215,8.73333088 C3.59591033,9.31700814 4.96952181,9.82690391 6.63796039,10.260015 C9.97516261,11.1262372 14.4929735,11.6769603 20.0035097,11.6769603 C25.6323669,11.6769603 30.1932479,11.1176334 33.5283372,10.2384244 C35.1961257,9.79898221 36.5576288,9.28186251 37.6115463,8.68771461 C38.6654638,8.09356671 39.4469831,7.42928989 39.8221807,6.54561664 C40.1973782,5.6619434 39.95968,4.5884188 39.2894928,3.83696782 C38.6193869,3.08519216 37.6022821,2.50752132 36.2097361,1.99356716 C33.4242376,0.965658829 31.0794386,0.238639335 24.8864442,0.00179185439 C24.85597,-0.000399674738 24.8254959,-0.000399674737 24.7950218,0.000817841442 C24.3063792,0.0240318166 23.9232177,0.430195214 23.9289062,0.919717886 Z"
                id="Fill-1"
              ></path>
            </g>
            <path
              d="M19.8354067,10.8412472 C17.3264404,10.8412472 15.3184557,8.83084287 15.3184557,6.3288856 C15.3184557,3.82149546 17.3255476,1.81652396 19.8354067,1.81652396 C22.3399087,1.81652396 24.3523578,3.82246851 24.3523578,6.3288856 C24.3523578,8.82995091 22.3389347,10.8412472 19.8354067,10.8412472 M13.500003,6.32929104 C13.500003,9.50346435 15.8650548,12.1416488 18.9263833,12.5873061 L18.9221625,32.919231 C18.9221625,33.1182199 19.0836909,33.2795031 19.282801,33.2795031 L20.3797331,33.2795031 C20.5789244,33.2795031 20.7403717,33.1182199 20.7403717,32.919231 L20.7444302,12.5869817 C23.8073009,12.1451355 26.1708105,9.50695111 26.1708105,6.32896669 C26.1708105,2.84033574 23.322878,0 19.8354067,0 C16.3441205,0 13.500003,2.84155206 13.500003,6.32929104 Z"
              id="Fill-4"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const LoginIcon = (props: { size?: number }) => {
  const LOGIN_ICON_VIEWBOX_SIZE = 20;
  const size = props.size ?? LOGIN_ICON_VIEWBOX_SIZE;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${LOGIN_ICON_VIEWBOX_SIZE} ${LOGIN_ICON_VIEWBOX_SIZE}`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>signout copy</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="signout-copy"
          transform="translate(9.999666, 10.000000) scale(-1, 1) translate(-9.999666, -10.000000) translate(1.000000, 1.000000)"
          fill="#14B2B6"
          stroke="#14B2B6"
          strokeWidth="0.05"
        >
          <path
            d="M13.4243998,3.4090565 L8.61,8.99961973 L8.61,8.99961973 L13.424192,14.5906503 C13.5917816,14.785283 13.8854208,14.8072057 14.0800535,14.639616 C14.0975892,14.6245167 14.1139735,14.6081297 14.1290698,14.5905915 C14.3316394,14.3552549 14.3316012,14.0071439 14.12898,13.7718518 L10.517955,9.57858127 L10.517955,9.57858127 L17.4207981,9.57858127 C17.7403134,9.57858127 17.9993318,9.3195629 17.9993318,9.00004753 C17.9993318,8.68053217 17.7403134,8.42151379 17.4207981,8.42151379 L10.517955,8.42151379 L10.517955,8.42151379 L14.1286128,4.22754364 C14.3310866,3.99235955 14.3311417,3.64446658 14.1287423,3.40921839 C13.9613692,3.21468108 13.6679828,3.19266016 13.4734455,3.36003328 C13.4558987,3.37512995 13.4395045,3.39151664 13.4243998,3.4090565 Z"
            id="Fill-1"
          ></path>
          <g id="Group">
            <path
              d="M0,0 L9.54830918,0 C9.82445155,-5.07265313e-17 10.0483092,0.223857625 10.0483092,0.5 C10.0483092,0.776142375 9.82445155,1 9.54830918,1 L0,1 L0,1 L0,0 Z"
              id="Rectangle"
            ></path>
            <polygon
              id="Rectangle"
              transform="translate(0.500000, 9.000000) rotate(-270.000000) translate(-0.500000, -9.000000) "
              points="-8.5 8.5 9.5 8.5 9.5 9.5 -8.5 9.5"
            ></polygon>
            <path
              d="M0,17 L9.54830918,17 C9.82445155,17 10.0483092,17.2238576 10.0483092,17.5 C10.0483092,17.7761424 9.82445155,18 9.54830918,18 L0,18 L0,18 L0,17 Z"
              id="Rectangle-Copy-7"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SearchIcon = (props: { size?: number; className?: string }) => {
  const size = props.size ?? 18;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66186 10.4913C1.15216 8.6999 0.990779 6.05298 2.20661 4.07372C3.41699 2.09392 5.8372 1.02144 8.13037 1.4948C10.7409 2.02591 12.6366 4.3247 12.654 6.96029C12.6366 9.27042 11.1672 11.4213 8.94874 12.2029C6.69537 12.9958 4.18901 12.3054 2.66186 10.4913ZM16.745 15.945C15.2871 14.5017 13.8292 13.0584 12.3653 11.6091C12.2873 11.532 12.2077 11.4532 12.1287 11.3749C12.9508 10.446 13.5211 9.30064 13.7141 8.06192C13.7719 7.69705 13.8063 7.33758 13.8063 6.96677C13.8063 6.96461 13.8063 6.96245 13.8063 6.96029C13.7888 4.14226 11.9907 1.61462 9.32297 0.645231C6.69504 -0.312823 3.59494 0.514612 1.82027 2.65364C-0.000752538 4.83854 -0.282629 7.98743 1.20963 10.4293C2.68498 12.8425 5.57189 14.0801 8.36067 13.5495C9.44946 13.3417 10.4581 12.8522 11.3032 12.1662L15.9321 16.7492C16.4566 17.2684 17.2749 16.4637 16.745 15.945Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MapDetectLocationIcon = (props: { size?: number }) => {
  const MAP_DETECT_LOCATION_VIEWBOX_SIZE = 38;
  const size = props.size ?? MAP_DETECT_LOCATION_VIEWBOX_SIZE;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${MAP_DETECT_LOCATION_VIEWBOX_SIZE} ${MAP_DETECT_LOCATION_VIEWBOX_SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6758 19.0049C15.6758 17.1695 17.1695 15.6758 19.0049 15.6758C20.8403 15.6758 22.334 17.1695 22.334 19.0049C22.334 20.8404 20.8403 22.3341 19.0049 22.3341C17.1695 22.3341 15.6758 20.8404 15.6758 19.0049ZM0.196728 19.0049C0.196728 18.5461 0.567719 18.18 1.02169 18.18H4.06771C4.26785 14.4945 5.79573 11.058 8.42682 8.43175C11.0579 5.79578 14.4944 4.26789 18.175 4.06775V1.02174C18.175 0.562885 18.546 0.196777 19 0.196777C19.454 0.196777 19.825 0.567766 19.825 1.02174V4.06775C23.5105 4.26789 26.947 5.79578 29.5732 8.42687C32.2043 11.058 33.7322 14.4945 33.9323 18.1751H36.9783C37.4323 18.1751 37.8033 18.5461 37.8033 19.0001C37.8033 19.454 37.4323 19.825 36.9783 19.825H33.9323C33.7322 23.5105 32.2043 26.947 29.5732 29.5732C26.9421 32.2043 23.5056 33.7322 19.825 33.9324V36.9784C19.825 37.4372 19.454 37.8033 19 37.8033C18.546 37.8033 18.175 37.4323 18.175 36.9784V33.9324C14.4896 33.7322 11.053 32.2043 8.42682 29.5732C5.79573 26.9421 4.26785 23.5056 4.06771 19.825H1.02169C0.567719 19.825 0.196728 19.4589 0.196728 19.0049ZM5.72739 18.1751H8.72459C9.18344 18.1751 9.54955 18.5461 9.54955 19.0001C9.54955 19.454 9.17856 19.825 8.72459 19.825H5.72739C6.13743 26.5077 11.4972 31.8675 18.175 32.2824V29.2852C18.175 28.8264 18.546 28.4603 19 28.4603C19.454 28.4603 19.825 28.8313 19.825 29.2852V32.2824C26.5076 31.8675 31.8723 26.5077 32.2824 19.8299H29.2852C28.8312 19.8299 28.4602 19.4589 28.4602 19.0049C28.4602 18.551 28.8312 18.18 29.2852 18.18H32.2824C31.8723 11.5022 26.5076 6.14236 19.8298 5.72744V8.72464C19.8298 9.18349 19.4589 9.5496 19.0049 9.5496C18.5509 9.5496 18.1799 9.17861 18.1799 8.72464V5.72744C11.4972 6.13748 6.13743 11.4973 5.72739 18.1751Z"
        fill="white"
      />
    </svg>
  );
};
